var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import CheckedListViewAll from "./CheckedListViewAll";
import EdButton, { EdButtonIcon, } from "@frameworks/web/components/generic/edbutton/edButton";
import { useNavigate, useParams } from "react-router-dom";
import { addCommasWithoutDecimal, roundUpToTwoDecimalPlaces, } from "@domains/utils/numberMethods";
import ShareSocialLinks from "@frameworks/shared-library/components/Generic/shareSocialLinks/shareSocialLinks";
import { getFinalShareUrl } from "@frameworks/web/utils/Navigate";
import { accountDetails } from "@mainDi/webDi";
import * as URLConfig from "@frameworks/web/config/domain";
var config = URLConfig.config;
import configUrl from "@frameworks/salesjourney/config/domain";
import GenericTooltip from "@frameworks/web/components/generic/GenericTooltip";
var TopFundsTableMobile = function (props) {
    var _a;
    var navigate = useNavigate();
    // const [checked, setChecked] = useState<Array<IMFCheckList>>([]);
    var _b = __read(useState([]), 2), checked = _b[0], setChecked = _b[1];
    var _c = __read(useState([]), 2), currentItem = _c[0], setCurrentItem = _c[1];
    var _d = __read(useState(false), 2), showShareModal = _d[0], setshowShareModal = _d[1];
    var socialshareUrl = getFinalShareUrl("TopPerformingFunds");
    var _e = __read(useState(), 2), tableData = _e[0], setTableData = _e[1];
    /* const handleCheck = (event: any) => {
      var updatedList = [...checked];
      if (event.target.checked) {
        updatedList = [
          ...checked,
          { schemeCode: event.target.value, schemeName: event.target.name },
        ];
      } else {
        updatedList.splice(
          checked.findIndex((x) => x.schemeCode === event.target.value),
          1
        );
      }
      setChecked(updatedList);
    }; */
    var handleCheck = function (event, tableRecord) {
        var _a = event.target, checked = _a.checked, value = _a.value, name = _a.name;
        var isin = tableRecord.isin, schCd = tableRecord.schCd;
        setChecked(function (prevChecked) {
            if (checked) {
                if (prevChecked.length < 3) {
                    return __spreadArray(__spreadArray([], __read(prevChecked), false), [
                        { schemeCode: value, schemeName: name, isin: isin, schCd: schCd },
                    ], false);
                }
                return prevChecked;
            }
            else {
                return prevChecked.filter(function (item) { return item.schemeCode !== value; });
            }
        });
    };
    var section = useParams().section;
    var navigateOnClick = function (element) {
        var route = (element === null || element === void 0 ? void 0 : element.category) === "Other" ? "index" : "mutualfunds";
        // navigate(
        //   `/rmjourneys/dashboard/product-quotes?schCode=${element?.schemeCode}&cat=${route}`
        // );
        var quoteUrl = "".concat(configUrl.quotesBase, "quotes/rm-quotes/").concat(route, "/").concat(element === null || element === void 0 ? void 0 : element.schemeCode, "?prefered_site=new");
        window.open(quoteUrl, "_blank");
    };
    return (React.createElement(React.Fragment, null,
        ((_a = props.mutualFundsSchemeList) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
            props.mutualFundsSchemeList.map(function (tableRecord) {
                return (React.createElement(Row, { onClick: function () { return navigateOnClick(tableRecord); }, className: "topFunds-mob ".concat(checked.findIndex(function (x) { return x.schemeCode === (tableRecord === null || tableRecord === void 0 ? void 0 : tableRecord.schemeCode); }) === -1
                        ? ""
                        : "bg_aqua_white") },
                    React.createElement(Row, { className: "py-3" },
                        React.createElement(Col, { className: "DMSanM_14_500 txt_blackOne1", xs: 12 }, tableRecord.schemeName)),
                    React.createElement(Row, null,
                        React.createElement(Col, null,
                            React.createElement("div", { className: "DMsanR_11_400 txt_primaryGrey fund-labels d-flex align-items-center" },
                                React.createElement("label", null,
                                    tableRecord.category,
                                    " "),
                                React.createElement("i", { className: "edel-icon-round-circle" }),
                                React.createElement("label", null, tableRecord.subCategory),
                                React.createElement("i", { className: "edel-icon-round-circle" }),
                                React.createElement("label", { className: "txt_secondary-gray DMSansMedium_11_500" }, "AUM"),
                                React.createElement("label", { className: "Roboto_11_400 num" }, tableRecord.expenseRatio
                                    ? "".concat(addCommasWithoutDecimal(tableRecord.aum), "Cr")
                                    : "NA"),
                                React.createElement("i", { className: "edel-icon-round-circle" }),
                                React.createElement("label", { className: "txt_secondary-gray DMSansMedium_11_500" }, "Exp"),
                                React.createElement("label", { className: "Roboto_11_400 num" }, tableRecord.expenseRatio
                                    ? "".concat(roundUpToTwoDecimalPlaces(Number(tableRecord.expenseRatio)), "%")
                                    : "NA")))),
                    React.createElement(Row, { className: "py-3" },
                        React.createElement(Col, null,
                            React.createElement("label", { className: "DMSansNormal_12_400 txt_primaryGrey mb-2" }, "1Y Ret"),
                            React.createElement("div", { className: "RobotoM_14_500 ".concat(tableRecord.year1 ? "txt_green " : "txt_blackOne1") }, tableRecord.year1 ? "".concat(tableRecord.year1, "%") : "NA")),
                        React.createElement(Col, { className: "taCenter" },
                            React.createElement("label", { className: "DMSansNormal_12_400 txt_primaryGrey mb-2" }, "3Y CAGR"),
                            React.createElement("div", { className: "RobotoM_14_500 ".concat(tableRecord.year3 ? "txt_green " : "txt_blackOne1") }, tableRecord.year3 ? "".concat(tableRecord.year3, "%") : "NA")),
                        React.createElement(Col, { className: "taRight" },
                            React.createElement("label", { className: "DMSansNormal_12_400 txt_primaryGrey mb-2" }, "5Y CAGR"),
                            React.createElement("div", { className: "RobotoM_14_500 ".concat(tableRecord.year5 ? "txt_green " : "txt_blackOne1") }, tableRecord.year5 ? "".concat(tableRecord.year5, "%") : "NA"))),
                    React.createElement(Row, { className: "pb-3" },
                        React.createElement(Col, { className: "d-flex align-items-center" },
                            React.createElement(EdButtonIcon, { btnIcon: "edel-icon-share-icon txt-midnight-blue", btnTyp: "link", onClick: function (e) {
                                    var element = e.target;
                                    if (element.tagName === "I") {
                                        e.stopPropagation();
                                    }
                                    setshowShareModal(true);
                                }, className: "bg_aqua_white share-btn" })),
                        React.createElement(Col, { className: "d-flex txt_secondary-gray DMSanM_14_500 align-items-center compare" },
                            React.createElement("div", { onClick: function (e) { return e.stopPropagation(); }, className: "fund-checkbox common-checkbox-custom small-checkbox" },
                                checked.findIndex(function (x) { return x.schemeCode === (tableRecord === null || tableRecord === void 0 ? void 0 : tableRecord.schemeCode); }) !== -1 ? (React.createElement("input", { value: tableRecord === null || tableRecord === void 0 ? void 0 : tableRecord.schemeCode, type: "checkbox", name: tableRecord === null || tableRecord === void 0 ? void 0 : tableRecord.schemeName, onChange: function (e) {
                                        var element = e.target;
                                        if (element.tagName === "BUTTON") {
                                            e.stopPropagation();
                                        }
                                        handleCheck(e, tableRecord);
                                    }, checked: checked.findIndex(function (x) { return x.schemeCode === (tableRecord === null || tableRecord === void 0 ? void 0 : tableRecord.schemeCode); }) > -1 })) : (checked === null || checked === void 0 ? void 0 : checked.length) < 3 ? (React.createElement("input", { value: tableRecord === null || tableRecord === void 0 ? void 0 : tableRecord.schemeCode, type: "checkbox", name: tableRecord === null || tableRecord === void 0 ? void 0 : tableRecord.schemeName, onChange: function (e) {
                                        var element = e.target;
                                        if (element.tagName === "BUTTON") {
                                            e.stopPropagation();
                                        }
                                        handleCheck(e, tableRecord);
                                    }, checked: checked.findIndex(function (x) { return x.schemeCode === (tableRecord === null || tableRecord === void 0 ? void 0 : tableRecord.schemeCode); }) > -1 })) : (React.createElement(GenericTooltip, { toolTipClassName: "desk-tooltips", placement: "top", triggerType: "hover", externalClassName: "remove-btn-props", toolTipText: "You can compare a maximum of 3 funds at a time", button: React.createElement("input", { value: tableRecord === null || tableRecord === void 0 ? void 0 : tableRecord.schemeCode, type: "checkbox", name: tableRecord === null || tableRecord === void 0 ? void 0 : tableRecord.schemeName, onChange: function (e) {
                                            var element = e.target;
                                            if (element.tagName === "BUTTON") {
                                                e.stopPropagation();
                                            }
                                            handleCheck(e, tableRecord);
                                        }, checked: checked.findIndex(function (x) {
                                            return x.schemeCode === (tableRecord === null || tableRecord === void 0 ? void 0 : tableRecord.schemeCode);
                                        }) > -1, disabled: true }) })),
                                "Compare")),
                        React.createElement(Col, { className: "taRight" },
                            React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Invest", slim: true, className: "invest-button", onClick: function (e) {
                                    var _a;
                                    var element = e.target;
                                    if (element.tagName === "BUTTON") {
                                        e.stopPropagation();
                                    }
                                    if (!accountDetails.isUserLoggedIn()) {
                                        var prevUrl = (_a = location === null || location === void 0 ? void 0 : location.pathname) === null || _a === void 0 ? void 0 : _a.replace(config === null || config === void 0 ? void 0 : config.subDomain, "");
                                        navigate("/login?redirectUrl=" +
                                            "/mutualfund/".concat(tableRecord.isin).concat(!!tableRecord.schCd
                                                ? "/".concat(tableRecord.schCd)
                                                : ""), {
                                            state: { prevUrl: prevUrl },
                                            // replace: true,
                                        });
                                    }
                                    else {
                                        navigate("/mutualfund/".concat(tableRecord.isin).concat(!!tableRecord.schCd ? "/".concat(tableRecord.schCd) : ""), {
                                            // replace: true,
                                            state: { redirectUrl: location.pathname },
                                        });
                                    }
                                } })))));
            }),
        checked && checked.length > 0 && (React.createElement(CheckedListViewAll, { checked: checked, setChecked: setChecked, page: "mutualFunds", currentItem: currentItem, setCurrentItem: setCurrentItem, isMarketPage: true, redirectionUrl: location.href, paramsData: props === null || props === void 0 ? void 0 : props.paramsData })),
        showShareModal && (React.createElement(ShareSocialLinks, { setShare: setshowShareModal, value: socialshareUrl }))));
};
export default TopFundsTableMobile;
